module.exports = __webpack_public_path__ + "img/scroll-down@3x.97ace22f.png";